import PinnedLocation from "src/types/PinnedLocation";

import axiosErrorHandler from "./apiError.handler";
import http from "./axios";

// Get PinnedLocations by UserId
export async function getPinnedLocations(): Promise<PinnedLocation[]> {
  try {
    const response = await http.get(`/Pinned`);
    return response.data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while getting UserPinnedLocations");
  }
}

// Post PinnedLocations
export async function postPinnedLocations(pinnedLocations: PinnedLocation[]): Promise<PinnedLocation[]> {
  try {
    const response = await http.post(`/Pinned`, pinnedLocations);
    return response.data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while post UserPinnedLocations");
  }
}
